// removed by extract-text-webpack-plugin
module.exports = {"Playground":"_129pMLHQ","shape":"_2lzTNFWL"};


//////////////////
// WEBPACK FOOTER
// ./client/components/SvgPlayground.styl
// module id = 649
// module chunks = 0